<template>
    <svg id="pageSvg" :width="canvasWidth" :height="canvasHeight" :viewBox="viewBox">
        <video-comp v-for="comp, index in canvas" :key="comp.id" :data="comp" :z="index"></video-comp>
    </svg>
</template>

<script>
	export default {
		props: {
			designWidth: Number,
			designHeight: Number,
			canvasWidth: Number,
			canvasHeight: Number
		},
		computed: {
			canvas(){
				return this.$store.state.canvas||[]
			},
			viewBox() {
				return `0 0 ${this.designWidth} ${this.designHeight}`
			}
		},
        mounted(){
        },
        methods:{
        }
	}
</script>
